// lib/sendPushNotification.ts
import { supabase } from './supabase';
import { createLogger } from './logger';
const log = createLogger('PUSH_SEND');

export async function sendPushToUser(userId: string, title: string, body: string, data?: Record<string, any>) {
  try {
    const { data: tokens } = await supabase.from('push_tokens').select('token').eq('user_id', userId);
    if (!tokens?.length) return;
    const messages = tokens.map(t => ({ to: t.token, sound: 'default' as const, title, body, data: data || {} }));
    await fetch('https://exp.host/--/api/v2/push/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(messages),
    });
  } catch (err) {
    log.error('Push send failed:', err);
  }
}
